export default __webpack_public_path__ + "files/media/plane-desktop@2x.999dd64b.jpg";